module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/photoalbums/bravenet_photo_albums_slideshow.png";